// extracted by mini-css-extract-plugin
export default {"main":"AuthPage_main__RzNNz","brand":"AuthPage_brand__rRCkO","header":"AuthPage_header__ys67K","content":"AuthPage_content__8npaM","authContainer":"AuthPage_authContainer__N6Fw5"};